<template>
  <div class="change-password">
    <h1>Wachtwoord veranderen</h1>
    <p>Kies geen wachtwoord dat je al ergens gebruikt want ik kan ze terugvinden in het database 😉</p>
    Wachtwoord:<br> <input type="password" v-model="changedPassword"><br><br>
    Herhaal wachtwoord:<br> <input type="password" v-model="repeatChangedPassword"><br><br>
    <div class="save">
      <button @click="changePassword">Opslaan</button>
      <button @click="close">Terug</button>
    </div>
  </div>
</template>

<script>

import jwt_decode from 'jwt-decode';

export default {
  name: 'ChangePassword',
  data() {
    return {
      userId: parseInt(jwt_decode(localStorage.getItem('token')).id),
      changedPassword: '',
      repeatChangedPassword: ''
    }
  },
  methods: {
    changePassword() {
      if (this.changedPassword.length < 4) {
        alert('Voer een geldig wachtwoord in van tenminste 4 karakters');
        return;
      }
      if (this.changedPassword !== this.repeatChangedPassword) {
        alert('Opgegeven wachtwoorden komen niet overeen');
        return;
      }

      const token = localStorage.getItem('token');

      this.axios.put(this.config.api + '/users/password', {
        id: this.userId,
        password: this.changedPassword
      }, {
          headers: {
            authorization: token
          }
        })
        .then(result => {
          if (result.data.status) {
            alert('Het wachtwoord is succesvol veranderd');
            this.close();
          } else alert(result.data.message);
        })
        .catch(error => {
          alert(error.message)
        })
    },
    close() {
      this.$emit('close');
    }
  }
}
</script>

<style scoped>

.change-password {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;

  font-family: 'Poppins', sans-serif;
  background-color: white;

  padding: 10px;

  z-index: 2;
}

.save {
  display: flex;
  justify-content: space-evenly;
}

</style>



// WEBPACK FOOTER //
// src/components/ChangePassword.vue